module.exports = __webpack_public_path__ + "img/guide-student5.69d2a20d.png";